var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.34375C4.65228 2.34375 2.34375 4.65228 2.34375 7.5C2.34375 10.3477 4.65228 12.6562 7.5 12.6562C10.3477 12.6562 12.6562 10.3477 12.6562 7.5C12.6562 4.65228 10.3477 2.34375 7.5 2.34375ZM1.40625 7.5C1.40625 4.13451 4.13451 1.40625 7.5 1.40625C10.8655 1.40625 13.5938 4.13451 13.5938 7.5C13.5938 10.8655 10.8655 13.5938 7.5 13.5938C4.13451 13.5938 1.40625 10.8655 1.40625 7.5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.75C7.75888 3.75 7.96875 3.95987 7.96875 4.21875V7.03125H10.7812C11.0401 7.03125 11.25 7.24112 11.25 7.5C11.25 7.75888 11.0401 7.96875 10.7812 7.96875H7.5C7.24112 7.96875 7.03125 7.75888 7.03125 7.5V4.21875C7.03125 3.95987 7.24112 3.75 7.5 3.75Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.fb890fd0b9fbb3ad9db6011d69d3e86a.svg";
export { ForwardRef as ReactComponent };